export default __webpack_public_path__ + "static/media/1_0152.3172a084.webp";